import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import ReduxThunk from "redux-thunk";

import { systemReducer } from "./systemReducer";
import { authReducer } from "./authReducer";
import { tokenReducer } from "./tokenReducer";
import { configReducer } from "./configReducer";
import { csrfTokenReducer } from "./csrfTokenReducer";

const middlewares = [ReduxThunk];
const reducer = combineReducers({
  authReducer: authReducer,
  systemReducer: systemReducer,
  tokenReducer: tokenReducer,
  configReducer: configReducer,
  csrfTokenReducer: csrfTokenReducer,
});

const store = createStore(reducer, {}, compose(applyMiddleware(...middlewares)));

export default store;
